module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1073.e7ea0c00.png";